import React from "react";
import AssignmentIcon from '@material-ui/icons/Assignment';

function Header() {
  return (
    <header>
      <h1>
       <AssignmentIcon /> Notii
      </h1>
    </header>
  );
}

export default Header;
